import {
    ActionReducerMap,
    createSelector,
    createFeatureSelector,
    ActionReducer,
    combineReducers,
    Action,
    ActionReducerFactory,
} from '@ngrx/store';
import { environment } from '../../../environments/environment';


import * as fromAppUi from '../reducers/app-ui.reducer';
import * as fromTestTaker from '../reducers/test-taker.reducer';

export interface State {
    appUi: fromAppUi.IAppUiState;
    testTaker: fromTestTaker.ITestTakerState;
}

export const reducers: ActionReducerMap<State> = {
    appUi: fromAppUi.appUiReducer,
    testTaker: fromTestTaker.testTakerReducer
};

// export function logger(reducer: ActionReducer<State>): ActionReducer<any, any> {
//   return function(state: State, action: any): State {
//     console.log('action', action);
//     return reducer(state, action);
//   };
// }

export const metaReducers: ActionReducer<any, any>[] = !environment.production ? [] : [];

/**
 * IAppUiState
 */
export const getAppUiState = createFeatureSelector<fromAppUi.IAppUiState>('appUi');
export const getIsLoading = createSelector(getAppUiState, fromAppUi.getIsLoading);
export const getIsLockScreenVisible = createSelector(getAppUiState, fromAppUi.getIsLockScreenVisible);
export const getIsExitScreenVisible = createSelector(getAppUiState, fromAppUi.getIsExitScreenVisible);
export const getIsPauseScreenVisible = createSelector(getAppUiState, fromAppUi.getIsPauseScreenVisible);
export const getGenericPage = createSelector(getAppUiState, fromAppUi.getGenericPage);
export const getIsNavigationModalVisible = createSelector(getAppUiState, fromAppUi.getIsNavigationModalVisible);

/**
 * ITestTakerState
 */
export const getTestTakerState = createFeatureSelector<fromTestTaker.ITestTakerState>('testTaker');
export const getAssessmentTest = createSelector(getTestTakerState, fromTestTaker.getAssessmentTest);
export const getTestlet = createSelector(getTestTakerState, fromTestTaker.getTestlet);
export const getItemIndex = createSelector(getTestTakerState, fromTestTaker.getItemIndex);
export const getAssessmentItem = createSelector(getTestTakerState, fromTestTaker.getAssessmentItem);
export const getCurrentTestletId = createSelector(getTestTakerState, fromTestTaker.getCurrentTestletId);
export const getNextTestletId = createSelector(getTestTakerState, fromTestTaker.getNextTestletId);
export const getTestNavigation = createSelector(getTestTakerState, fromTestTaker.getTestNavigation);
export const getTestTakerInfo = createSelector(getTestTakerState, fromTestTaker.getTestTakerInfo);
export const getResponses = createSelector(getTestTakerState, fromTestTaker.getResponses);
export const getTimer = createSelector(getTestTakerState, fromTestTaker.getTimer);
export const getTestTakerActivitiesCache = createSelector(getTestTakerState, fromTestTaker.getTestTakerActivitiesCache);
export const getFlushPayload = createSelector(getTestTakerState, fromTestTaker.getFlushPayload);
export const shouldGoToNextTestlet = createSelector(getTestTakerState, fromTestTaker.shouldGoToNextTestlet);
export const getAssociatedAssessmentTests = createSelector(getTestTakerState, fromTestTaker.getAssociatedAssessmentTests);
export const getTimerVisibility = createSelector(getTestTakerState, fromTestTaker.getTimerVisibility);
export const getStoredHighlights = createSelector(getTestTakerState, fromTestTaker.getStoredHighlights);
export const getTestletHistory = createSelector(getTestTakerState, fromTestTaker.getTestletHistory);
export const getIsNavigatingInProgress = createSelector(getTestTakerState, fromTestTaker.getIsNavigatingInProgress);



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/store/reducers/index.ts